module.exports = require("@swa-ui/core/src/DialogSubheading/DialogSubheading.module.scss");